// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  ASSIGN_CASE_SUMMARY_CASE_DETAILS_TERR_CASE_ID,
  ASSIGN_CASE_SUMMARY_CHANNEL_CASE_LIST,
  ASSIGN_CASE_SUMMARY_OPEN_SUMMARY,
  ASSIGN_CASE_SUMMARY_SELECTED_TERR_CASE_IDS,
  CASE_SUMMARY_SHOW_ALL_CASES_TOGGLE,
  UPDATE_INTERFERENCE_ANALYSIS_STATE,
  ASSIGN_CASE_SUMMARY_CASE_OH_DETAILS_TERR_CASE_ID,
} from './types'

export const assignCaseSummaryCaseDetailsTerrCaseId = caseDetailsTerrCaseId => ({
  type: ASSIGN_CASE_SUMMARY_CASE_DETAILS_TERR_CASE_ID,
  caseDetailsTerrCaseId,
})

export const assignCaseSummaryCaseOhDetailsTerrCaseId = caseOhDetailsTerrCaseId => ({
  type: ASSIGN_CASE_SUMMARY_CASE_OH_DETAILS_TERR_CASE_ID,
  caseOhDetailsTerrCaseId,
})

export const assignCaseSummaryChannelCaseList = (channelCaseList = []) => ({
  type: ASSIGN_CASE_SUMMARY_CHANNEL_CASE_LIST,
  channelCaseList,
})

export const assignCaseSummaryOpenSummary = openSummaryUID => ({
  type: ASSIGN_CASE_SUMMARY_OPEN_SUMMARY,
  openSummaryUID,
})

export const assignCaseSummarySelectedTerrCaseIds = selectedTerrCaseIds => ({
  type: ASSIGN_CASE_SUMMARY_SELECTED_TERR_CASE_IDS,
  selectedTerrCaseIds,
})

export const caseSummaryShowAllCasesToggle = () => ({
  type: CASE_SUMMARY_SHOW_ALL_CASES_TOGGLE,
})

export const updateInterferenceAnalysisState = newState => ({
  type: UPDATE_INTERFERENCE_ANALYSIS_STATE,
  newState,
})
